import { endOfWeek, startOfWeek } from 'date-fns'
import { DateRange } from 'react-day-picker'
import { ru } from 'date-fns/locale'

interface Props {
  defaultValue?: DateRange
  defaultPeriod?: 'today' | 'week' | 'month' | 'year'
}

export const getDefaultDateRange = ({ defaultValue, defaultPeriod }: Props): DateRange | undefined => {
  const now = new Date()
  const startOfDay = new Date(now)
  startOfDay.setHours(0, 0, 0, 0)

  if (defaultValue) return defaultValue

  // Если defaultPeriod не передан, возвращаем undefined
  if (!defaultPeriod) return undefined

  switch (defaultPeriod) {
    case 'week':
      return {
        from: startOfWeek(now, { locale: ru }),
        to: endOfWeek(now, { locale: ru }),
      }
    case 'month':
      return {
        from: new Date(now.getFullYear(), now.getMonth(), 1),
        to: new Date(now.getFullYear(), now.getMonth() + 1, 0),
      }
    case 'year':
      return {
        from: new Date(now.getFullYear(), 0, 1),
        to: new Date(now.getFullYear(), 11, 31),
      }
    case 'today':
      return {
        from: startOfDay,
        to: now,
      }
  }
}
